var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center",staticStyle:{"height":"100%"}},[(_vm.params.data)?_c('vs-button',{staticClass:"btnx",attrs:{"size":"small","type":"filled"},on:{"click":_vm.sendMessage}},[_vm._v(" "+_vm._s(_vm.$t('ButtonText'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }